import { render, staticRenderFns } from "./EbookAccess.vue?vue&type=template&id=b4029250&scoped=true"
import script from "./EbookAccess.vue?vue&type=script&lang=js"
export * from "./EbookAccess.vue?vue&type=script&lang=js"
import style0 from "./EbookAccess.vue?vue&type=style&index=0&id=b4029250&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4029250",
  null
  
)

export default component.exports